<script setup>
import VueMultiselect from "vue-multiselect"
import {computed, inject} from "vue";
import {decodeDate} from "../../../../../frontend/src/helpers/date";

const props = defineProps({
    value: {},
    fieldName: {},
    label: {},
    type: {
        default: "text",
    },
    required: {
        default: false,
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    options: {
        type: Array,
    },
    updateOptionsMethod: {
        type: Function,
    },
});

const emit = defineEmits(['input']);

const form = inject('form');
const lastUpdates = inject('lastUpdates');
const errors = inject('errors');

const model = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
    }
});
</script>

<template>
    <div class="form__item">
        <h5 class="heading5 heading5--secondary">
            {{label}}
            <template v-if="required"> *</template>
        </h5>

        <slot name="input">
            <VueMultiselect
                v-if="value !== undefined"
                v-model="model"
                :multiple="multiple"
                :placeholder="`Select ${label}`"
                :options="options"
                select-label=""
                deselect-label=""
                label="name"
                track-by="name"
                class="multiselect-mid pl-2"
            />

            <textarea
                v-else-if="type === 'textarea'"
                v-model="form[fieldName]"
                class="form-control--mid form-control"
            />

            <select
                v-else-if="type === 'select'"
                v-model="form[fieldName]"
                class="selectbox selectbox-mid w-100"
            >
                <option v-for="option in options" :key="option.value" :value="option.value">
                    {{option.name}}
                </option>
            </select>

            <VueMultiselect
                v-else-if="type === 'multiselect'"
                v-model="form[fieldName]"
                :multiple="multiple"
                :placeholder="`Select ${label}`"
                :options="options"
                select-label=""
                deselect-label=""
                label="name"
                track-by="name"
                class="multiselect-mid pl-2"
            />

            <input
                v-else
                v-model="form[fieldName]"
                :type="type"
                class="form-control--mid form-control"
            >
        </slot>

        <template v-if="errors[fieldName]?.length">
            <span
                v-for="(error, index) in errors[fieldName]"
                :key="index"
                class="form__error"
            >
                {{error}}
            </span>
        </template>

        <div
            v-if="lastUpdates[fieldName]"
            style="font-size:11pt; color:grey"
            class="text-right"
        >
            (last edit: {{decodeDate(lastUpdates[fieldName].date)}},
            {{ lastUpdates[fieldName].source }})
        </div>
    </div>
</template>

<style scoped>

</style>
